// Every API call is relative. The Express server that serves this bundle also
// serves /api and /auth, so the client follows whichever host it was loaded
// from and works unchanged on loadfetcher.com and app.loadfetcher.com.
//
// Do not reintroduce an absolute base. It would send traffic from the app's own
// hostname back to loadfetcher.com, and because CORS is permissive it would
// appear to work while quietly routing everything through the legacy domain.
export const baseURL = ''
